import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";

const SocialMediaIcons = () => {
  const iconStyle =
    "text-white text-[12px] lg:text-[24px] group-hover:scale-110 transition-transform duration-300";

  return (
    <div className="flex space-x-2 lg:space-x-2">
      <a
        href="https://www.facebook.com/share/15T7qsvrmk/"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#1877F2] w-[20px] h-[20px] lg:w-[40px] lg:h-[40px] rounded-full flex justify-center items-center group hover:opacity-90 transition-opacity duration-300"
      >
        <FaFacebookF className={iconStyle} />
      </a>

      <a
        href="https://www.instagram.com/gobies.cs?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#E1306C] w-[20px] h-[20px] lg:w-[40px] lg:h-[40px] rounded-full flex justify-center items-center group hover:opacity-90 transition-opacity duration-300"
      >
        <FaInstagram className={iconStyle} />
      </a>

      <a
        href="https://wa.me/16177776772"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#25D366] w-[20px] h-[20px] lg:w-[40px] lg:h-[40px] rounded-full flex justify-center items-center group hover:opacity-90 transition-opacity duration-300"
      >
        <FaWhatsapp className={iconStyle} />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
